<template>
    <div class="container">
        <div class="row">
            <heading>
                {{ $t('savedData.types.unloadingAddress') }}
                <template v-slot:actions>
                    <a href="/saved-data/unloading-address/create" class="btn btn-primary">{{ $t('core.actions.add') }}</a>
                </template>
            </heading>
        </div>
        <div class="row">
            <Card class="col-12">
                <div class="card-body">
                    <table class="table" v-if="addresses.length > 0">
                        <thead>
                        <tr>
                            <th class="border-top-0">{{ $t('booking.fields.name') }}</th>
                            <th class="border-top-0">{{ $t('booking.fields.address') }}</th>
                            <th class="border-top-0"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="address in addresses" :key="address.id">
                            <td>{{ address.name }}</td>
                            <td>{{ address.address }} {{ address.address2 }}, {{ address.country }}</td>
                            <td class="text-right">
                                <a :href="'/saved-data/unloading-address/' + address.id" class="btn btn-sm btn-outline-primary">{{ $t('core.actions.edit') }}</a>
                                <p class="btn btn-sm btn-outline-danger mb-0" @click.prevent.stop="deleteItem(address)">{{ $t('core.actions.delete') }}</p>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div v-if="addresses.length === 0" class="text-center">
                    {{ $t('savedData.emptyStates.unloadingAddress') }}<br />
                    <a href="/saved-data/unloading-address/create" class="btn btn-sm btn-primary mt-2">{{ $t('core.actions.add') }}</a>
                </div>
            </Card>
        </div>
    </div>
</template>

<script>

import Card from '@/Components/Card'
export default {
    name: 'SavedUnloadingAddressIndex',
    components: {Card},
    data: () => {
        return {
            addresses: lgt.addresses
        }
    },
    methods: {
        deleteItem(address){
            const response = confirm(this.$t('savedData.confirmDelete'));
            if(response === false){
                return;
            }
            let index = this.addresses.findIndex((x) => x.id === address.id);
            axios.post('/address/' + address.id, {"_method": "DELETE"}).then((response) => {
                this.addresses.splice(index,1);
            })
        },
    }
}
</script>
